import EconomicCalendar from '../../components/common/EconomicCalendar';

const AdminEconomicCalendar = () => {
  return <EconomicCalendar />;
};

export default AdminEconomicCalendar;
